module.exports = __webpack_public_path__ + "img/magento-setup-tuning_small.17049ad2.jpg";